import { Outlet, useLocation } from "react-router-dom";
import Header  from "./Header";
import Footer  from "./Footer";
import { useState } from "react";

const routeTitles = {
  "/home": "",
  "/dashboard": "",
}

const MainLayout = () => {
    const token = localStorage.getItem("token");
    const location = useLocation();

    const pageTitle = routeTitles[location.pathname] || "Page";
    const isOnboarding = location.pathname.startsWith("/onboarding");

   return (
    <div>
      {token && <Header onboarding={isOnboarding}/>} 

      <main className="mainOuter">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout
